module.exports = __webpack_public_path__ + "img/ICON-SPEAK-UP.a81680f9.png";